import React from "react";
import clsx from "clsx";
import classes from "./ContentHeader.module.css";

interface Props {
    header: string;
    whiteText?: boolean;
    forSite?: boolean;
    className?: string;
}

const ContentHeader = ({ header, whiteText, forSite, className }: Props) => {
    return (
        <div
            className={clsx(
                classes.contentHeader,
                whiteText ? "whiteStyle" : "gradientStyle",
                forSite && classes.forSite,
                className,
            )}>
            <h2>{header}</h2>
            {!forSite && <hr />}
        </div>
    );
};

export default ContentHeader;
